import React from 'react'
import { Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export const ActionTooltip = ({ action, disabled = false, children }) => {
  const { t } = useTranslation(['services'])

  return disabled ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <Tooltip
      leaveDelay={0}
      title={t(`services::account_list.extra_actions.${action}`)}
    >
      {children}
    </Tooltip>
  )
}

ActionTooltip.propTypes = {
  children: PropTypes.element,
  disabled: PropTypes.bool,
  action: PropTypes.string,
}
